import { render, staticRenderFns } from "./UserRolesAddEdit.vue?vue&type=template&id=058f9c11&"
import script from "./UserRolesAddEdit.vue?vue&type=script&lang=js&"
export * from "./UserRolesAddEdit.vue?vue&type=script&lang=js&"
import style0 from "./UserRolesAddEdit.vue?vue&type=style&index=0&id=058f9c11&prod&scopped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports